import React from 'react';
import { PageHeader } from 'react-bootstrap';

//Info on sales, contact information (sales@splinter-log.com)
//link to discuss forum
//links to docs

class Support extends React.Component {
	render() { 
		return (
			<div className="pageContents">
				<PageHeader>Support</PageHeader>
				<h3>Sales Questions</h3>
				Contact <a href="mailto:sales@splinter-log.com">sales@splinter-log.com</a>.
				
				<h3>Troubleshooting</h3>
				Hop on to the <a href="http://discuss.splinter-log.com">discuss forum</a>!
				
				<h3>Resources</h3>
				<ul>
					<li><a href="/#/docs/custom-log-format">Tutorial on custom log formats</a></li>
                	<li><a href="/#/docs/producing-graphs">Tutorial on instrumenting your code for producing graphs</a></li>
               		
               	</ul>
               	
               	
			</div>
			);
	}
}

export default Support;





// WEBPACK FOOTER //
// ./src/Support.js